import { Stack, Text } from "@chakra-ui/react";
import useTranslate from "@raiden/library/hooks/useTranslate";
import { Href } from "../../../../../components/Href";
import {
  getMenuItemAdapterType,
  getMenuItemAdapterValues,
} from "../../../../../helpers/menus/getMenuItemAdapterValues";

/**
 * @param {object} params
 * @param {number} params.depth
 * @returns {import("@chakra-ui/react").TextProps}
 */
function getStyle({ depth }) {
  if (depth === 0) {
    return {
      variant: "h4",
    };
  }
  return {
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: "1.375rem",
    color: "gray.600",
  };
}

/**
 * @typedef {Object} Props
 * @property {import("@raiden/library/types/Configuration").ConfigurationMenuItem} menuItem
 * @property {number} depth
 * @property {{ id: number, slug: string}} [postCategoryData]
 *
 * @param {Props} props
 */
export function SubMenuItem({ menuItem, depth, postCategoryData }) {
  const translate = useTranslate();

  const type = getMenuItemAdapterType({ menuItem });

  if (type === undefined) {
    return null;
  }

  const { title, href, target } = getMenuItemAdapterValues({
    menuItem,
    translate,
    postCategoryData,
  });

  return (
    <Stack spacing="0.5rem">
      <Href href={href} target={target}>
        <Text
          as="span"
          display="inline-block"
          color="brandPrimary.900"
          fontWeight={500}
          _hover={{ textDecoration: href ? "underline" : undefined }}
          {...getStyle({ depth })}>
          {title}
        </Text>
      </Href>

      {menuItem.children.length > 0 && (
        <>
          <Stack spacing="0.125rem">
            {menuItem.children.map((menuItem, index) => {
              return (
                <SubMenuItem
                  menuItem={menuItem}
                  depth={depth + 1}
                  key={index}
                />
              );
            })}
          </Stack>
        </>
      )}
    </Stack>
  );
}
